module.exports = {"name":"","description":"","parking":"","hours":"","location":"","moreInfo":"","tags":["test"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/template.json
// module id = ./src/data/template.json
// module chunks = main